module.exports = __webpack_public_path__ + "img/c1.ffc7d4fc.png";